import React from "react";
import "./SlotGamesSoftwareStyle.scss";
import { slotGamesSoftwareTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";
import CustomButton from "components/Common_UI_Kit/CustomButton";
import { useNavigate } from "react-router-dom";

const SlotGamesSoftwareSection = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate(`/contact-us`);
  };

  return (
    <section className="slot-games-software-section">
      <div className="slot-games-software-wrap">
        <SectionHeading>
          {slotGamesSoftwareTextContent.headingText}
        </SectionHeading>

        <div className="slot-games-software-box">
          {slotGamesSoftwareTextContent.content.map((section, index) => (
            <div className="slot-games-software-container" key={index}>
              <div className="slot-games-software-container-inner">
                <div className="text-box">
                  <h5 className="title-text">{section.titleText}</h5>
                  <h6 className="subtitle-text">{section.titleText}</h6>
                  <p className="para-text">{section.paraText}</p>

                  {section.listContent && section.listContent.length > 0 && (
                    <ul className="list-text-box">
                      {section.listContent.map((item, itemIndex) => (
                        <li className="list-text" key={itemIndex}>{item.listText}</li>
                      ))}
                    </ul>
                  )}
                </div>

                <div className="img-box">
                  <img src={section.imageSrc} alt="Image" />
                </div>
              </div>
            </div>
          ))}

          <div className="btn-box">
            <CustomButton
              buttonType="secondary"
              label={slotGamesSoftwareTextContent.btnText}
              onClick={handleButtonClick}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SlotGamesSoftwareSection;
